import { DropDownList } from '@progress/kendo-react-dropdowns';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useMessageFilterCategories from 'src/assets/static/view_message/useMessageFilterCategories';
import useDebounceCallback from 'src/hooks/useDebounceCallback';
import useViewMessage from 'src/hooks/useViewMessage';
import ClearFilters from 'src/sections/view_message/table_toolbar/ClearFilters';
import { Message } from 'src/services/messages_services/useGetMessageApi';
import { SetState } from 'src/types/generic';

interface ViewMessagesTableToolbarProps {
  deletedFilter: { value: string; label: string };
  setDeletedFilter: SetState<{ value: string; label: string }>;
  filteredMessages: Message[];
  clearFilter: () => void;
}

function ViewMessagesTableToolbar({
  deletedFilter = { value: 'not deleted', label: 'Show All Active' },
  setDeletedFilter,
  filteredMessages,
  clearFilter,
}: ViewMessagesTableToolbarProps) {
  const totalFilteredCount = filteredMessages.length;

  const { messageWithFilters, messages, hasEditMessagePermission, messagesDataState } =
    useViewMessage();

  const selectedRows = useMemo(() => messages.filter((item: Message) => item.selected), [messages]);

  const { t } = useTranslation();

  // Debounce dropdown filter changes to prevent rapid state updates (300ms delay)
  const [debouncedSetDeletedFilter] = useDebounceCallback(
    (value: { value: string; label: string }) => {
      setDeletedFilter(value);
    },
    300
  );

  if (!messages || messages.length === 0) {
    return (
      <div className="message-layout toolbar-container">
        <div className="flex items-center gap-1 text-white text-sm">
          {t('No messages found or not authorized.')}
        </div>
      </div>
    );
  }

  const filterCategories = useMessageFilterCategories;

  return (
    <div className="message-layout toolbar-container">
      <div className="flex items-center gap-3 text-white text-sm">
        <ClearFilters clearFilter={clearFilter} deletedFilter={deletedFilter} />
      </div>
      <div>
        <DropDownList
          id="messages-grid-dropdown"
          style={{ width: 200, height: 23, minHeight: '23px', backgroundColor: 'white' }}
          data={filterCategories}
          textField="label"
          dataItemKey="value"
          value={deletedFilter ?? { value: 'not deleted', label: 'Show All Active' }}
          onChange={(e) => debouncedSetDeletedFilter(e.value)}
        />
      </div>
    </div>
  );
}

export default ViewMessagesTableToolbar;
